import { render, staticRenderFns } from "./something-went-wrong.vue?vue&type=template&id=3309acbe&scoped=true&"
import script from "./something-went-wrong.vue?vue&type=script&lang=ts&"
export * from "./something-went-wrong.vue?vue&type=script&lang=ts&"
import style0 from "./something-went-wrong.vue?vue&type=style&index=0&id=3309acbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3309acbe",
  null
  
)

export default component.exports